import React from 'react';
import { Card, OfferCard } from '@wegroup/design-system';
import { Offer } from '../../../../../../../../types/Offer';
import { useOffer } from '../../../../../../../parties/src/api/getOfferById';
import LoadingSpinner from '../../../../../../../common/src/components/LoadingSpinner';

interface Props {
  offer: Offer;
  label?: string;
  logo?: string;
  onSelect: (offer: Offer) => void;
}

const PrefillOfferModalOffersCard: React.FC<Props> = ({
  offer,
  label,
  logo,
  onSelect,
}) => {
  const { data: bigOffer, isLoading } = useOffer({
    offerId: offer.id,
    revision: offer.revision,
  });
  if (!bigOffer || isLoading)
    return (
      <Card h="80">
        <LoadingSpinner />
      </Card>
    );

  const handleSelect = () => {
    onSelect({ ...bigOffer, insurance: offer.insurance });
  };

  return (
    <OfferCard
      offer={bigOffer}
      label={label}
      logo={logo}
      isSelectable
      onSelect={handleSelect}
    />
  );
};

export default PrefillOfferModalOffersCard;
